module.exports = __webpack_public_path__ + "assets/images/Order_Type_A_Icon.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/Order_Type_A_Icon.png
// module id = 241
// module chunks = 1